// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Task Mode Reports — match Access Requests spacing */
/* Flowchest button styling */
.btn {
  font-family: inherit !important;
  font-weight: 500 !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
  cursor: pointer !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  min-height: 40px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
  box-sizing: border-box !important;
  padding: 8px 16px !important;
  font-size: 14px !important;
}

.btn-primary {
  background-color: #5ea1d8 !important;
  color: #fff !important;
  border: none !important;
}

.btn-primary:hover {
  background-color: #4a8bc4 !important;
  box-shadow: 0 2px 6px rgba(94, 161, 216, 0.25) !important;
}

.btn-ghost {
  background: transparent !important;
  color: #1d67a3 !important;
  border: 1px solid #c5d8ea !important;
}

.btn:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Summary cards (same as access-requests / content-approvals) */
.com-record {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
  border: none !important;
}

.com-record:after {
  content: "";
  width: 100%;
  height: 60%;
  top: 0px;
  position: absolute;
  left: 0px;
  z-index: 0;
}

.followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;
}

.followers-tag .box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
  gap: 12px;
}

.followers-tag .box .icon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.followers-tag .box .ico-box {
  width: 40px;
  height: 40px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
}

.followers-tag .box .card-icon {
  font-size: 20px;
  color: #5ea1d8;
}

.followers-tag .box .text {
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1;
  justify-content: center;
  gap: 2px;
}

.followers-tag .box .text .count {
  background: white !important;
  box-shadow: none !important;
  display: flex;
  align-items: center;
}

.followers-tag .box .text .count b {
  font-size: 24px;
  font-weight: 700 !important;
  color: #333;
  display: block;
  line-height: 1.2;
}

.followers-tag .box .text p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.2;
  display: block;
}

/* Dashboard shell — same as content-approvals / access-requests */
.setting-dashboard {
  padding: 0;
  height: auto;
  position: relative;
  margin-top: 0;
  background: var(--fc-bg, #fff);
}
.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0px;
}

.dashbored-wrap {
  padding-left: 0px;
  margin-top: 0;
}
.dashbored-wrap .table-wrap {
  padding: 30px 30px 30px 0;
  width: 100%;
  left: 0;
}
.dashbored-wrap .filter {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  border: none;
  padding: 0 0 16px;
}
.dashbored-wrap .table-parent {
  overflow-x: auto;
  margin-top: -8px;
}

.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: fixed;
  position: absolute;
  top: 0px;
  width: 83.333333%;
  padding-left: 0px;
  border-left: 1px solid #fff;
}

.scroll-div {
  position: sticky;
  top: var(--app-header) !important;
  margin-top: 0 !important;
  width: 100%;
  padding-bottom: 20px;
}
.scroll-div .dash-text {
  padding: 10px 15px 0;
}

.filters-section {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: nowrap;
  align-items: center;
  overflow: visible;
  width: 100%;
}

.filter {
  width: 100%;
}
.filter .flow-filter {
  display: flex;
  align-items: center;
  align-self: center;
  flex: 1 1 auto;
  min-width: 200px;
  max-width: 480px;
  overflow: visible;
}
.filter .status-filter {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: #fff;
  font-size: 14px;
  font: inherit;
  color: #333;
}
.filter .toolbar-actions {
  display: inline-flex;
  flex: 0 0 auto;
  flex-wrap: nowrap;
  gap: 8px;
  align-items: center;
  align-self: center;
  margin-left: auto;
  height: 40px;
}
.filter .toolbar-actions .btn,
.filter .toolbar-actions button.mat-mdc-button-base {
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
  margin: 0 !important;
  padding: 0 16px !important;
  line-height: 1 !important;
  vertical-align: middle !important;
  box-sizing: border-box !important;
}
.filter .toolbar-actions .btn .mdc-button__label,
.filter .toolbar-actions button.mat-mdc-button-base .mdc-button__label {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  line-height: 1 !important;
}
.filter .toolbar-actions .btn mat-icon,
.filter .toolbar-actions button.mat-mdc-button-base mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
  margin: 0 !important;
}
.filter .toolbar-actions .btn .mat-mdc-button-touch-target,
.filter .toolbar-actions button.mat-mdc-button-base .mat-mdc-button-touch-target {
  height: 40px !important;
}

.tmr-tabs {
  display: flex;
  gap: 8px;
  margin: 12px 30px 0 0;
  border-bottom: 2px solid #eaecf0;
}

.tmr-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  margin-bottom: -2px;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  color: #667085;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;
}
.tmr-tab mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.tmr-tab:hover {
  color: #1d67a3;
}

.tmr-tab--active {
  color: #1d67a3;
  border-bottom-color: #5ea1d8;
}

.tmr-tab__badge {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  background: #f2f4f7;
  color: #475467;
}

.tmr-tab--active .tmr-tab__badge {
  background: #5ea1d8;
  color: #fff;
}

.dashbored-wrap .table-wrap.tmr-toolbar {
  padding-top: 20px;
  padding-bottom: 0;
}

.dashbored-wrap .table-wrap.tmr-runs {
  padding-top: 0;
}

.submitter {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.submitter .muted {
  font-size: 12px;
  color: #667085;
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.8rem;
}

@media (max-width: 767px) {
  .scroll-div {
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
  }
  .setting-dashboard .submission-field {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap {
    margin-top: 10px !important;
  }
  .com-record {
    padding: 12px 16px 20px;
  }
  .dashbored-wrap .table-wrap {
    padding: 0;
  }
  .followers-tag {
    gap: 12px;
  }
  .tmr-tabs {
    margin: 8px 16px 0;
  }
  .tmr-tab {
    flex: 1;
    justify-content: center;
    padding: 10px 8px;
  }
  .followers-tag .box {
    width: 100%;
    margin: 6px 0;
    min-width: auto;
  }
  .filter,
  .filters-section {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }
  .filters-section {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 16px;
    padding: 0 20px;
  }
  .filter .flow-filter {
    width: 100%;
    max-width: 100%;
  }
  .filter .status-filter {
    width: 100%;
    min-width: 0;
  }
  .filter .toolbar-actions {
    width: 100%;
    height: auto;
    min-height: 40px;
    margin-left: 0;
    flex-wrap: wrap;
  }
}
:host-context(body.theme-dark) .filter .status-filter {
  background: #1b1f27;
  border-color: #2f3542;
  color: #e2e8f0;
}
:host-context(body.theme-dark) .followers-tag .box {
  background: #1b1f27;
  border-color: #2f3542;
}
:host-context(body.theme-dark) .followers-tag .box .text .count b {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .submitter .muted {
  color: #98a2b3;
}
:host-context(body.theme-dark) .tmr-tabs {
  border-bottom-color: rgba(148, 163, 184, 0.15);
}
:host-context(body.theme-dark) .tmr-tab {
  color: #94a3b8;
}
:host-context(body.theme-dark) .tmr-tab:hover {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .tmr-tab--active {
  color: #5ea1d8;
}
:host-context(body.theme-dark) .tmr-tab__badge {
  background: #2f3542;
  color: #cbd5e1;
}
:host-context(body.theme-dark) .tmr-tab--active .tmr-tab__badge {
  background: #5ea1d8;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/task-mode-reports/task-mode-reports.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,sDAAA;AAEA,6BAAA;AACA;EACE,+BAAA;EACA,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,0BAAA;EACA,+BAAA;EACA,4BAAA;EACA,2BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iCAAA;EACA,4BAAA;EACA,0BAAA;AACF;;AAEA;EACE,oCAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,oCAAA;EACA,yDAAA;AACF;;AAEA;EACE,kCAAA;EACA,yBAAA;EACA,oCAAA;AACF;;AAEA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;AACF;;AAEA,gEAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oDAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,uBAAA;EACA,QAAA;AACF;;AAEA;EACE,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,2BAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA,kEAAA;AACA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AACF;AACE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAGA;EACE,iBAAA;EACA,aAAA;AAAF;AAEE;EACE,yBAAA;EACA,WAAA;EACA,OAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AADJ;AAIE;EACE,gBAAA;EACA,gBAAA;AAFJ;;AAMA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AAHF;;AAMA;EACE,gBAAA;EACA,iCAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AAHF;AAKE;EACE,oBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAJF;;AAOA;EACE,WAAA;AAJF;AAME;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AALJ;AAQE;EACE,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AANJ;AAQI;;EAEE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,oBAAA;EACA,0BAAA;EACA,yBAAA;EACA,iCAAA;EACA,iCAAA;AANN;AAQM;;EACE,+BAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;AALR;AAQM;;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oBAAA;AALR;AAQM;;EACE,uBAAA;AALR;;AAWA;EACE,aAAA;EACA,QAAA;EACA,qBAAA;EACA,gCAAA;AARF;;AAWA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,qDAAA;AARF;AAUE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AARJ;AAWE;EACE,cAAA;AATJ;;AAaA;EACE,cAAA;EACA,4BAAA;AAVF;;AAaA;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AAVF;;AAaA;EACE,mBAAA;EACA,WAAA;AAVF;;AAaA;EACE,iBAAA;EACA,iBAAA;AAVF;;AAaA;EACE,cAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAVF;AAYE;EACE,eAAA;EACA,cAAA;AAVJ;;AAcA;EACE,qEAAA;EACA,iBAAA;AAXF;;AAcA;EACE;IACE,wBAAA;IACA,yBAAA;IACA,qBAAA;IACA,oBAAA;IACA,iBAAA;EAXF;EAcA;IACE,WAAA;IACA,SAAA;EAZF;EAeA;IACE,2BAAA;EAbF;EAgBA;IACE,uBAAA;EAdF;EAiBA;IACE,UAAA;EAfF;EAkBA;IACE,SAAA;EAhBF;EAmBA;IACE,kBAAA;EAjBF;EAoBA;IACE,OAAA;IACA,uBAAA;IACA,iBAAA;EAlBF;EAqBA;IACE,WAAA;IACA,aAAA;IACA,eAAA;EAnBF;EAsBA;;IAEE,sBAAA;IACA,0BAAA;IACA,sBAAA;EApBF;EAuBA;IACE,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,mBAAA;IACA,eAAA;EArBF;EAyBE;IACE,WAAA;IACA,eAAA;EAvBJ;EA0BE;IACE,WAAA;IACA,YAAA;EAxBJ;EA2BE;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,cAAA;IACA,eAAA;EAzBJ;AACF;AA8BE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA5BJ;AA+BE;EACE,mBAAA;EACA,qBAAA;AA7BJ;AAgCE;EACE,cAAA;AA9BJ;AAiCE;EACE,cAAA;AA/BJ;AAkCE;EACE,8CAAA;AAhCJ;AAmCE;EACE,cAAA;AAjCJ;AAmCI;EACE,cAAA;AAjCN;AAqCE;EACE,cAAA;AAnCJ;AAsCE;EACE,mBAAA;EACA,cAAA;AApCJ;AAuCE;EACE,mBAAA;EACA,WAAA;AArCJ","sourcesContent":["/* Task Mode Reports — match Access Requests spacing */\n\n/* Flowchest button styling */\n.btn {\n  font-family: inherit !important;\n  font-weight: 500 !important;\n  border-radius: 8px !important;\n  transition: all 0.2s ease !important;\n  cursor: pointer !important;\n  text-transform: none !important;\n  letter-spacing: 0 !important;\n  min-height: 40px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 6px !important;\n  box-sizing: border-box !important;\n  padding: 8px 16px !important;\n  font-size: 14px !important;\n}\n\n.btn-primary {\n  background-color: #5ea1d8 !important;\n  color: #fff !important;\n  border: none !important;\n}\n\n.btn-primary:hover {\n  background-color: #4a8bc4 !important;\n  box-shadow: 0 2px 6px rgba(94, 161, 216, 0.25) !important;\n}\n\n.btn-ghost {\n  background: transparent !important;\n  color: #1d67a3 !important;\n  border: 1px solid #c5d8ea !important;\n}\n\n.btn:disabled {\n  opacity: 0.6 !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Summary cards (same as access-requests / content-approvals) */\n.com-record {\n  width: 100%;\n  height: auto;\n  position: relative;\n  z-index: 0;\n  padding: 20px 30px 30px;\n  border: none !important;\n}\n\n.com-record:after {\n  content: \"\";\n  width: 100%;\n  height: 60%;\n  top: 0px;\n  position: absolute;\n  left: 0px;\n  z-index: 0;\n}\n\n.followers-tag {\n  display: flex;\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.followers-tag .box {\n  width: auto;\n  padding: 5px 10px;\n  background: #fff;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  gap: 12px;\n}\n\n.followers-tag .box .icon {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.followers-tag .box .ico-box {\n  width: 40px;\n  height: 40px;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0;\n}\n\n.followers-tag .box .card-icon {\n  font-size: 20px;\n  color: #5ea1d8;\n}\n\n.followers-tag .box .text {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  flex: 1;\n  justify-content: center;\n  gap: 2px;\n}\n\n.followers-tag .box .text .count {\n  background: white !important;\n  box-shadow: none !important;\n  display: flex;\n  align-items: center;\n}\n\n.followers-tag .box .text .count b {\n  font-size: 24px;\n  font-weight: 700 !important;\n  color: #333;\n  display: block;\n  line-height: 1.2;\n}\n\n.followers-tag .box .text p {\n  margin: 0;\n  font-size: 14px;\n  color: #666;\n  line-height: 1.2;\n  display: block;\n}\n\n/* Dashboard shell — same as content-approvals / access-requests */\n.setting-dashboard {\n  padding: 0;\n  height: auto;\n  position: relative;\n  margin-top: 0;\n  background: var(--fc-bg, #fff);\n\n  .row {\n    flex-direction: row;\n    height: 100%;\n    margin: 0px;\n  }\n}\n\n.dashbored-wrap {\n  padding-left: 0px;\n  margin-top: 0;\n\n  .table-wrap {\n    padding: 30px 30px 30px 0;\n    width: 100%;\n    left: 0;\n  }\n\n  .filter {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0;\n    border: none;\n    padding: 0 0 16px;\n  }\n\n  .table-parent {\n    overflow-x: auto;\n    margin-top: -8px;\n  }\n}\n\n.setting-dashboard .submission-field {\n  left: 16.666667%;\n  padding-right: 0;\n  position: fixed;\n  position: absolute;\n  top: 0px;\n  width: 83.333333%;\n  padding-left: 0px;\n  border-left: 1px solid #fff;\n}\n\n.scroll-div {\n  position: sticky;\n  top: var(--app-header) !important;\n  margin-top: 0 !important;\n  width: 100%;\n  padding-bottom: 20px;\n\n  .dash-text {\n    padding: 10px 15px 0;\n  }\n}\n\n.filters-section {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: nowrap;\n  align-items: center;\n  overflow: visible;\n  width: 100%;\n}\n\n.filter {\n  width: 100%;\n\n  .flow-filter {\n    display: flex;\n    align-items: center;\n    align-self: center;\n    flex: 1 1 auto;\n    min-width: 200px;\n    max-width: 480px;\n    overflow: visible;\n  }\n\n  .status-filter {\n    width: 100%;\n    height: 40px;\n    box-sizing: border-box;\n    padding: 0 12px;\n    border-radius: 4px;\n    border: 1px solid #ddd;\n    background-color: #fff;\n    font-size: 14px;\n    font: inherit;\n    color: #333;\n  }\n\n  .toolbar-actions {\n    display: inline-flex;\n    flex: 0 0 auto;\n    flex-wrap: nowrap;\n    gap: 8px;\n    align-items: center;\n    align-self: center;\n    margin-left: auto;\n    height: 40px;\n\n    .btn,\n    button.mat-mdc-button-base {\n      height: 40px !important;\n      min-height: 40px !important;\n      max-height: 40px !important;\n      margin: 0 !important;\n      padding: 0 16px !important;\n      line-height: 1 !important;\n      vertical-align: middle !important;\n      box-sizing: border-box !important;\n\n      .mdc-button__label {\n        display: inline-flex !important;\n        align-items: center !important;\n        gap: 6px !important;\n        line-height: 1 !important;\n      }\n\n      mat-icon {\n        font-size: 18px !important;\n        width: 18px !important;\n        height: 18px !important;\n        line-height: 18px !important;\n        margin: 0 !important;\n      }\n\n      .mat-mdc-button-touch-target {\n        height: 40px !important;\n      }\n    }\n  }\n}\n\n.tmr-tabs {\n  display: flex;\n  gap: 8px;\n  margin: 12px 30px 0 0;\n  border-bottom: 2px solid #eaecf0;\n}\n\n.tmr-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 18px;\n  margin-bottom: -2px;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  color: #667085;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  transition: color 0.15s ease, border-color 0.15s ease;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &:hover {\n    color: #1d67a3;\n  }\n}\n\n.tmr-tab--active {\n  color: #1d67a3;\n  border-bottom-color: #5ea1d8;\n}\n\n.tmr-tab__badge {\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  background: #f2f4f7;\n  color: #475467;\n}\n\n.tmr-tab--active .tmr-tab__badge {\n  background: #5ea1d8;\n  color: #fff;\n}\n\n.dashbored-wrap .table-wrap.tmr-toolbar {\n  padding-top: 20px;\n  padding-bottom: 0;\n}\n\n.dashbored-wrap .table-wrap.tmr-runs {\n  padding-top: 0;\n}\n\n.submitter {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n\n  .muted {\n    font-size: 12px;\n    color: #667085;\n  }\n}\n\n.mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 0.8rem;\n}\n\n@media (max-width: 767px) {\n  .scroll-div {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    top: 0 !important;\n  }\n\n  .setting-dashboard .submission-field {\n    width: 100%;\n    left: 0px;\n  }\n\n  .dashbored-wrap {\n    margin-top: 10px !important;\n  }\n\n  .com-record {\n    padding: 12px 16px 20px;\n  }\n\n  .dashbored-wrap .table-wrap {\n    padding: 0;\n  }\n\n  .followers-tag {\n    gap: 12px;\n  }\n\n  .tmr-tabs {\n    margin: 8px 16px 0;\n  }\n\n  .tmr-tab {\n    flex: 1;\n    justify-content: center;\n    padding: 10px 8px;\n  }\n\n  .followers-tag .box {\n    width: 100%;\n    margin: 6px 0;\n    min-width: auto;\n  }\n\n  .filter,\n  .filters-section {\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box;\n  }\n\n  .filters-section {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    margin-bottom: 16px;\n    padding: 0 20px;\n  }\n\n  .filter {\n    .flow-filter {\n      width: 100%;\n      max-width: 100%;\n    }\n\n    .status-filter {\n      width: 100%;\n      min-width: 0;\n    }\n\n    .toolbar-actions {\n      width: 100%;\n      height: auto;\n      min-height: 40px;\n      margin-left: 0;\n      flex-wrap: wrap;\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .filter .status-filter {\n    background: #1b1f27;\n    border-color: #2f3542;\n    color: #e2e8f0;\n  }\n\n  .followers-tag .box {\n    background: #1b1f27;\n    border-color: #2f3542;\n  }\n\n  .followers-tag .box .text .count b {\n    color: #e2e8f0;\n  }\n\n  .submitter .muted {\n    color: #98a2b3;\n  }\n\n  .tmr-tabs {\n    border-bottom-color: rgba(148, 163, 184, 0.15);\n  }\n\n  .tmr-tab {\n    color: #94a3b8;\n\n    &:hover {\n      color: #cbd5e1;\n    }\n  }\n\n  .tmr-tab--active {\n    color: #5ea1d8;\n  }\n\n  .tmr-tab__badge {\n    background: #2f3542;\n    color: #cbd5e1;\n  }\n\n  .tmr-tab--active .tmr-tab__badge {\n    background: #5ea1d8;\n    color: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
